module.exports = __webpack_public_path__ + "media/images/pic/hero/waves-a6b88f7234c412b779fe849e674a75d3.webp";